let enabledPlugins = [];
let pluginConfig = {};
let app = null;
let store = null;
let router = null;

export function enable(pluginName, config = {}) {
    if (Array.isArray(pluginName)) {
        pluginName.forEach(pluginName => enable(pluginName));
        return;
    }

    if (isEnabled(pluginName)) {
        throw `Plugin "${pluginName}" has already been enabled.`;
    }

    let plugin = resolvePlugin(pluginName);

    for (let requiredPlugin of plugin.requiredPlugins) {
        if (!isEnabled(requiredPlugin)) {
            enable(requiredPlugin);
        }
    }

    if (config instanceof Function) {
        config = config(plugin.defaultConfig);
    } else {
        config = {...plugin.defaultConfig, ...config};
    }

    enabledPlugins.push(pluginName);
    pluginConfig[pluginName] = config;
    plugin.install(app, {store, router, ...config});
}

export function isEnabled(pluginName) {
    return enabledPlugins.includes(pluginName);
}

export function getPluginConfig(pluginName) {
    if (!isEnabled(pluginName)) {
        throw `Plugin "${pluginName}" is not enabled.`;
    }
    return pluginConfig[pluginName];
}

export function makeReactiveBase(config) {
    let reactiveBase = app.extend(config);
    return new reactiveBase;
}

export function mergeRouteMeta(route) {
    let matched = route.matched || [];
    return matched.reduce((result, route) => ({...result, ...route.meta}), {});
}

export default {
    install(Vue, config = {}) {
        app = Vue;
        store = config.store;
        router = config.router;
    },
    enable,
    isEnabled,
    getPluginConfig,
    makeReactiveBase,
    mergeRouteMeta,
};

function resolvePlugin(pluginName) {
    let plugin;

    switch (pluginName) {
        case 'api': plugin = require('./plugins/apiPlugin'); break;
        case 'env': plugin = require('./plugins/envPlugin'); break;
        case 'form': plugin = require('./plugins/formPlugin'); break;
        case 'i18n': plugin = require('./plugins/i18nPlugin'); break;
        case 'modal': plugin = require('./plugins/modalPlugin'); break;
        case 'moment': plugin = require('./plugins/momentPlugin'); break;
        case 'notify': plugin = require('./plugins/notifyPlugin'); break;
        case 'provider': plugin = require('./plugins/providerPlugin'); break;
        case 'ui': plugin = require('./plugins/uiPlugin'); break;
        case 'redactor': plugin = require('./plugins/redactorPlugin'); break;
        case 'queue': plugin = require('./plugins/queuePlugin'); break;
        default:
            throw `Unknown plugin: ${pluginName}`;
    }

    if (plugin.hasOwnProperty('default')) {
        plugin = plugin.default; // compatibility with export default (old style)
    }

    return {
        defaultConfig: {},
        requiredPlugins: [],
        ...plugin,
    };
}

export const Socket = require('./socket').default;